(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[43289,93812,33051],{

/***/ 59870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ChallengesAndSolutions; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/BlogCommon/Article/ContentfulParser/index.jsx
var ContentfulParser = __webpack_require__(92870);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./UI/containers/CustomSwiper/index.jsx + 2 modules
var CustomSwiper = __webpack_require__(33051);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 92 modules
var swiper_esm = __webpack_require__(44040);
// EXTERNAL MODULE: ./UI/components/ChallengesSlider/styles.module.scss
var styles_module = __webpack_require__(36157);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/ChallengesSlider/utils/challengesSliderHelper.js




var getSwiperParams = function(type) {
    var pagination = type === constants/* CASE_STUDIES_TYPES.challengesSpecialSlider */.vA.challengesSpecialSlider ? {} : {
        spaceBetween: 50,
        autoHeight: true,
        pagination: {
            type: "bullets",
            clickable: true,
            bulletClass: (styles_module_default()).swiperBullet,
            bulletActiveClass: (styles_module_default()).swiperBulletActive
        }
    };
    return (0,_object_spread/* default */.Z)({
        modules: [
            swiper_esm/* Pagination */.tl
        ]
    }, pagination);
};

;// CONCATENATED MODULE: ./UI/components/ChallengesSlider/utils/useChallengesSlider.js


var useChallengesSlider = function(param) {
    var type = param.type, componentType = param.componentType, isMobileResolution = param.isMobileResolution, isSlider = param.isSlider, children = param.children;
    var isSpecialSwiper = componentType === constants/* CASE_STUDIES_TYPES.challengesSpecialSlider */.vA.challengesSpecialSlider;
    var swiperParams = getSwiperParams(componentType);
    return {
        type: type,
        isMobileResolution: isMobileResolution,
        isSlider: isSlider,
        children: children,
        isSpecialSwiper: isSpecialSwiper,
        swiperParams: swiperParams
    };
};

;// CONCATENATED MODULE: ./UI/components/ChallengesSlider/index.jsx







var ChallengesSlider = function(props) {
    var ref = useChallengesSlider(props), type = ref.type, isMobileResolution = ref.isMobileResolution, isSlider = ref.isSlider, children = ref.children, isSpecialSwiper = ref.isSpecialSwiper, swiperParams = ref.swiperParams;
    if (!isMobileResolution || !isSlider) return children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSwiper["default"], {
        className: classnames_default()((styles_module_default()).swiper, (styles_module_default())[type]),
        swiperParams: swiperParams,
        isShowNavigation: isSpecialSwiper,
        navigationClassName: (styles_module_default()).navigation,
        children: children.map(function(child, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                children: child
            }, index);
        })
    });
};
ChallengesSlider.defaultProps = {
    isMobileResolution: false
};
ChallengesSlider.propTypes = {
    isSlider: (prop_types_default()).bool.isRequired,
    children: prop_types_default().arrayOf((prop_types_default()).node).isRequired,
    type: (prop_types_default()).string.isRequired,
    componentType: (prop_types_default()).string.isRequired,
    isMobileResolution: (prop_types_default()).bool
};
/* harmony default export */ var components_ChallengesSlider = (ChallengesSlider);

// EXTERNAL MODULE: ./components/CaseStudiesCommon/utils/data.js
var data = __webpack_require__(27515);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./UI/components/Typography/index.jsx
var Typography = __webpack_require__(59654);
// EXTERNAL MODULE: ./UI/components/Media/index.jsx + 2 modules
var Media = __webpack_require__(34190);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./redux/selectors/layout.js
var layout = __webpack_require__(19341);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/components/ChallengesAndSolutions/utils/helpers.js

var disabledSlider = function(type) {
    return ![
        constants/* CASE_STUDIES.generativeAi */.qU.generativeAi, 
    ].includes(type);
};

;// CONCATENATED MODULE: ./UI/components/ChallengesAndSolutions/utils/useChallengesAndSolutions.js






var useChallengesAndSolutions = function(param) {
    var data = param.data, type = param.type, isSpecial = param.isSpecial, view = param.view;
    var componentType = data.type, contentModules = data.contentModules, rawImages = data.images;
    var isMobileResolution = (0,es.useSelector)(layout/* selectIsMobile */.eD);
    var isSlider = [
        constants/* CASE_STUDIES_TYPES.challengesSlider */.vA.challengesSlider,
        constants/* CASE_STUDIES_TYPES.challengesSpecialSlider */.vA.challengesSpecialSlider
    ].includes(data.type);
    var isSliderDisabled = disabledSlider(type);
    var images = (rawImages || []).map(function(rawImage) {
        return (0,helper/* getImage */.gJ)(rawImage);
    });
    var content = contentModules === null || contentModules === void 0 ? void 0 : contentModules.map(function(document) {
        var ref = (0,helper/* getDocumentFields */.OA)(document), title = ref.title, blockImages = ref.images, text = ref.text, imagesBundles = ref.imagesBundles, subtitle = ref.subtitle, _contentList = ref.contentList, contentList = _contentList === void 0 ? [] : _contentList;
        var subImage = (0,helper/* getImage */.gJ)(get_default()(blockImages, "[1]", ""));
        var imagesBundlesWithUrl = (imagesBundles === null || imagesBundles === void 0 ? void 0 : imagesBundles.map(function(bundle) {
            return (0,helper/* getImage */.gJ)(bundle);
        })) || [];
        return {
            title: title,
            text: text,
            subtitle: subtitle,
            contentList: contentList,
            asset: !!(blockImages === null || blockImages === void 0 ? void 0 : blockImages[0]) && blockImages[0],
            subImage: subImage,
            imagesBundles: imagesBundlesWithUrl
        };
    });
    return {
        type: type,
        isSpecial: isSpecial,
        view: view,
        isSlider: isSlider,
        isMobileResolution: isMobileResolution,
        content: content,
        componentType: componentType,
        images: images,
        isSliderDisabled: isSliderDisabled
    };
};

// EXTERNAL MODULE: ./UI/components/ChallengesAndSolutions/styles.module.scss
var ChallengesAndSolutions_styles_module = __webpack_require__(92764);
var ChallengesAndSolutions_styles_module_default = /*#__PURE__*/__webpack_require__.n(ChallengesAndSolutions_styles_module);
;// CONCATENATED MODULE: ./UI/components/ChallengesAndSolutions/index.jsx















var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var ChallengesAndSolutions = function(props) {
    var ref = useChallengesAndSolutions(props), type = ref.type, isSpecial = ref.isSpecial, view = ref.view, isSlider = ref.isSlider, isMobileResolution = ref.isMobileResolution, content = ref.content, componentType = ref.componentType, images = ref.images, isSliderDisabled = ref.isSliderDisabled;
    if (!content) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((ChallengesAndSolutions_styles_module_default())[type], (ChallengesAndSolutions_styles_module_default())[view]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ChallengesSlider, {
                isMobileResolution: isMobileResolution,
                isSlider: isSlider && isSliderDisabled,
                componentType: componentType,
                type: type,
                children: content === null || content === void 0 ? void 0 : content.map(function(param, index) {
                    var title = param.title, text = param.text, imagesBundles = param.imagesBundles, subtitle = param.subtitle, contentList = param.contentList, image = param.image, subImage = param.subImage, asset = param.asset;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((ChallengesAndSolutions_styles_module_default()).contentContainer, (ChallengesAndSolutions_styles_module_default())["contentContainer-".concat(index + 1)], (0,_define_property/* default */.Z)({}, (ChallengesAndSolutions_styles_module_default()).special, isSpecial)),
                        children: [
                            !asset && title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data/* ANIMATION_CASE_STUDY_PROPS */.e), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((ChallengesAndSolutions_styles_module_default()).infoContainer, (ChallengesAndSolutions_styles_module_default()).separatedTitle),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                        variant: "h2",
                                        className: (ChallengesAndSolutions_styles_module_default()).title,
                                        children: title
                                    })
                                })
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((ChallengesAndSolutions_styles_module_default()).infoContainer, (ChallengesAndSolutions_styles_module_default())["infoContainer-".concat(index + 1)], (0,_define_property/* default */.Z)({}, (ChallengesAndSolutions_styles_module_default()).centrefy, asset)),
                                children: [
                                    subImage.url && /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                                        transparent: true,
                                        className: (ChallengesAndSolutions_styles_module_default()).subImage,
                                        src: subImage.url,
                                        alt: subImage.alt
                                    }),
                                    asset && subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data/* ANIMATION_CASE_STUDY_PROPS */.e), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                                variant: "p",
                                                className: classnames_default()((ChallengesAndSolutions_styles_module_default()).subtitle, (ChallengesAndSolutions_styles_module_default())["subtitle-".concat(index + 1)]),
                                                children: subtitle
                                            })
                                        })
                                    })),
                                    asset && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data/* ANIMATION_CASE_STUDY_PROPS */.e), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                                                variant: "h2",
                                                className: classnames_default()((ChallengesAndSolutions_styles_module_default()).title, (ChallengesAndSolutions_styles_module_default())["title-".concat(index + 1)]),
                                                children: title
                                            })
                                        })
                                    })),
                                    text && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        delay: 100
                                    }, data/* ANIMATION_CASE_STUDY_PROPS */.e), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                                            document: text
                                        })
                                    })),
                                    !!contentList.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: (ChallengesAndSolutions_styles_module_default()).listContainer,
                                        children: contentList === null || contentList === void 0 ? void 0 : contentList.map(function(item, contentIndex) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                delay: 50 + 10 * contentIndex
                                            }, data/* ANIMATION_CASE_STUDY_PROPS */.e), {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: (ChallengesAndSolutions_styles_module_default()).listItem,
                                                    children: item
                                                })
                                            }));
                                        })
                                    })
                                ]
                            }),
                            (asset || !!imagesBundles.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data/* ANIMATION_CASE_STUDY_PROPS */.e), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((ChallengesAndSolutions_styles_module_default()).images, (ChallengesAndSolutions_styles_module_default())["images-".concat(index + 1)]),
                                    children: [
                                        asset && /*#__PURE__*/ (0,jsx_runtime.jsx)(Media["default"], {
                                            asset: asset,
                                            className: classnames_default()((ChallengesAndSolutions_styles_module_default()).image, (ChallengesAndSolutions_styles_module_default())["image-".concat(index + 1)])
                                        }),
                                        imagesBundles === null || imagesBundles === void 0 ? void 0 : imagesBundles.map(function(imageBundle, imagesBundlesIndex) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                                                transparent: true,
                                                className: classnames_default()((ChallengesAndSolutions_styles_module_default()).imageBundle, (ChallengesAndSolutions_styles_module_default())["imageBundle-".concat(imagesBundlesIndex + 1)]),
                                                src: imageBundle.url,
                                                alt: imageBundle.alt
                                            }, "bundles-images/".concat(imageBundle.url));
                                        })
                                    ]
                                })
                            }))
                        ]
                    }, title || image);
                })
            }),
            !!images.length && images.map(function(image) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                    src: image.url,
                    className: (ChallengesAndSolutions_styles_module_default()).sectionImage
                }, image.url);
            })
        ]
    });
};
ChallengesAndSolutions.defaultProps = {
    type: "",
    isSpecial: false,
    view: ""
};
ChallengesAndSolutions.propTypes = {
    data: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string,
    isSpecial: (prop_types_default()).bool,
    view: (prop_types_default()).string
};
/* harmony default export */ var components_ChallengesAndSolutions = (ChallengesAndSolutions);


/***/ }),

/***/ 93812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Illustration; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./UI/components/Illustration/styles.module.scss
var styles_module = __webpack_require__(31890);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Illustration/utils/useIllustration.js





/* harmony default export */ function useIllustration(_param) {
    var src = _param.src, isStatic = _param.isStatic, classnames = _param.className, _lazyBoundary = _param.lazyBoundary, lazyBoundary = _lazyBoundary === void 0 ? "700px" : _lazyBoundary, apiParams = _param.apiParams, transparent = _param.transparent, placeholderProp = _param.placeholder, priority = _param.priority, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "isStatic",
        "className",
        "lazyBoundary",
        "apiParams",
        "transparent",
        "placeholder",
        "priority"
    ]);
    var loader = isStatic ? function(param) {
        var staticSrc = param.src;
        return staticSrc;
    } : function(args) {
        return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
            transparent: transparent
        }, args, apiParams));
    };
    var className = classnames_default()((styles_module_default()).image, classnames);
    var lazyProps = !priority ? {
        placeholder: placeholderProp || (transparent ? "blur" : "empty"),
        blurDataURL: (0,helpers/* getContentfulImage */.t)({
            src: src,
            quality: 1,
            format: "webp",
            transparent: transparent
        })
    } : {};
    return (0,_object_spread/* default */.Z)({
        src: src,
        loader: loader,
        className: className,
        lazyBoundary: lazyBoundary,
        priority: priority
    }, lazyProps, rest);
};

;// CONCATENATED MODULE: ./UI/components/Illustration/index.jsx








var Illustration = /*#__PURE__*/ (0,react.memo)(function(props) {
    var _ref = useIllustration(props), className = _ref.className, style = _ref.style, containerClasses = _ref.containerClasses, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "className",
        "style",
        "containerClasses"
    ]);
    if (!(restProps === null || restProps === void 0 ? void 0 : restProps.src) || restProps.placeholder === "blur" && !restProps.blurDataURL) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        className: classnames_default()(className, containerClasses),
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, restProps))
    });
});
Illustration.defaultProps = {
    layout: "fill",
    alt: "",
    transparent: false,
    apiParams: {}
};
Illustration.propTypes = {
    transparent: (prop_types_default()).bool,
    // For more props check https://nextjs.org/docs/api-reference/next/legacy/image
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string,
    layout: prop_types_default().oneOf([
        "fill",
        "intrinsic",
        "fixed",
        "responsive", 
    ]),
    placeholder: prop_types_default().oneOf([
        "blur",
        "empty", 
    ]),
    // Check https://www.contentful.com/developers/docs/references/images-api/ for detailed api
    apiParams: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var components_Illustration = (Illustration);


/***/ }),

/***/ 70731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SwiperNavButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./UI/components/SwiperNavButton/utils/useSwiperNavButton.js



var useSwiperNavButton = function(_param) {
    var buttonRef = _param.buttonRef, type = _param.type, text = _param.text, className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "buttonRef",
        "type",
        "text",
        "className"
    ]);
    var svgType = type === "next" ? "arrowRight" : "arrowLeft";
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        buttonRef: buttonRef,
        type: type,
        text: text,
        svgType: svgType,
        className: className
    });
};

// EXTERNAL MODULE: ./UI/components/SwiperNavButton/styles.module.scss
var styles_module = __webpack_require__(5713);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/SwiperNavButton/index.jsx









var Svg = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var SwiperNavButton = function(props) {
    var _ref = useSwiperNavButton(props), buttonRef = _ref.buttonRef, type = _ref.type, text = _ref.text, svgType = _ref.svgType, className = _ref.className, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "buttonRef",
        "type",
        "text",
        "svgType",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        type: "button",
        className: classnames_default()(className, (styles_module_default()).navButton, (styles_module_default())[type]),
        ref: buttonRef,
        "data-swiper-button": true
    }, rest), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                type: svgType
            }),
            text && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (styles_module_default()).text,
                children: text
            })
        ]
    }));
};
SwiperNavButton.defaultProps = {
    className: "",
    text: ""
};
SwiperNavButton.propTypes = {
    type: prop_types_default().oneOf([
        "next",
        "prev"
    ]).isRequired,
    text: (prop_types_default()).string,
    className: (prop_types_default()).string
};
/* harmony default export */ var components_SwiperNavButton = (SwiperNavButton);


/***/ }),

/***/ 33051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ containers_CustomSwiper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 92 modules
var swiper_esm = __webpack_require__(44040);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/components/SwiperNavButton/index.jsx + 1 modules
var SwiperNavButton = __webpack_require__(70731);
// EXTERNAL MODULE: ./UI/components/SwiperNavigation/styles.module.scss
var styles_module = __webpack_require__(35133);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/SwiperNavigation/index.jsx





var SwiperNavigation = function(param) {
    var className = param.className, navigationPrevRef = param.navigationPrevRef, navigationNextRef = param.navigationNextRef;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(className, (styles_module_default()).navigationContainer),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperNavButton/* default */.Z, {
                type: "prev",
                text: "previous",
                buttonRef: navigationPrevRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperNavButton/* default */.Z, {
                type: "next",
                text: "next",
                buttonRef: navigationNextRef
            })
        ]
    });
};
SwiperNavigation.defaultProps = {
    className: null
};
SwiperNavigation.propTypes = {
    className: (prop_types_default()).string
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./UI/containers/CustomSwiper/utils/useCustomSwiper.js

var useCustomSwiper = function(param) {
    var children = param.children, swiperParams = param.swiperParams, isShowNavigation = param.isShowNavigation, navigationClassName = param.navigationClassName, className = param.className;
    var navigationPrevRef = (0,react.useRef)(null);
    var navigationNextRef = (0,react.useRef)(null);
    var onSwiperInit = function(swiper) {
        swiper.params.navigation.prevEl = navigationPrevRef.current;
        swiper.params.navigation.nextEl = navigationNextRef.current;
        swiper.navigation.init();
        swiper.navigation.update();
    };
    return {
        children: children,
        swiperParams: swiperParams,
        isShowNavigation: isShowNavigation,
        navigationClassName: navigationClassName,
        className: className,
        navigationPrevRef: navigationPrevRef,
        navigationNextRef: navigationNextRef,
        onSwiperInit: onSwiperInit
    };
};

// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/swiper/modules/scrollbar/scrollbar.min.css
var scrollbar_min = __webpack_require__(13390);
// EXTERNAL MODULE: ./node_modules/swiper/modules/free-mode/free-mode.min.css
var free_mode_min = __webpack_require__(30706);
;// CONCATENATED MODULE: ./UI/containers/CustomSwiper/index.jsx














var CustomSwiper = function(props) {
    var ref = useCustomSwiper(props), children = ref.children, swiperParams = ref.swiperParams, isShowNavigation = ref.isShowNavigation, navigationClassName = ref.navigationClassName, className = ref.className, navigationNextRef = ref.navigationNextRef, navigationPrevRef = ref.navigationPrevRef, onSwiperInit = ref.onSwiperInit;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, swiperParams), {
        onInit: isShowNavigation ? onSwiperInit : undefined,
        modules: (0,_to_consumable_array/* default */.Z)(swiperParams.modules || []).concat([
            swiper_esm/* Navigation */.W_, 
        ]),
        className: className,
        children: [
            children,
            isShowNavigation && /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperNavigation, {
                className: navigationClassName,
                navigationPrevRef: navigationPrevRef,
                navigationNextRef: navigationNextRef
            })
        ]
    }));
};
SwiperNavigation.defaultProps = {
    isShowNavigation: false,
    navigationClassName: null
};
SwiperNavigation.propTypes = {
    isShowNavigation: (prop_types_default()).bool,
    navigationClassName: (prop_types_default()).string,
    swiperParams: prop_types_default().instanceOf(Object),
    children: prop_types_default().arrayOf((prop_types_default()).node)
};
/* harmony default export */ var containers_CustomSwiper = (CustomSwiper);


/***/ }),

/***/ 27515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ ANIMATION_CASE_STUDY_PROPS; }
/* harmony export */ });
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96076);

var ANIMATION_CASE_STUDY_PROPS = {
    type: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ANIMATED_TYPE.isFade */ .BK.isFade,
    duration: 1000
};


/***/ }),

/***/ 92764:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"styles_contentContainer__sScq9","centrefy":"styles_centrefy__5RDMv","infoContainer":"styles_infoContainer__LUqIG","listContainer":"styles_listContainer__lHap1","listItem":"styles_listItem__vdwfS","separatedTitle":"styles_separatedTitle__t5Way","title":"styles_title__vJ0p8","image":"styles_image__MjRwD","imageBundle":"styles_imageBundle__whWXD","subImage":"styles_subImage__GVoGI","stickerbox":"styles_stickerbox__lLJaT","special":"styles_special__GMGAv","swiperBullet":"styles_swiperBullet__wpIqr","swiperBulletActive":"styles_swiperBulletActive__tUY7f","fireaway":"styles_fireaway__mxlHq","contentContainer-3":"styles_contentContainer-3__GZqIA","images":"styles_images__K9iF0","images-1":"styles_images-1__FvgdQ","images-2":"styles_images-2__5Z4GJ","contentContainer-2":"styles_contentContainer-2__CtrxU","fairy":"styles_fairy__BrQF7","firstSectionView":"styles_firstSectionView__eerpF","image-1":"styles_image-1__viHF5","secondSectionView":"styles_secondSectionView__yg7zP","seven-pm-thursday":"styles_seven-pm-thursday__n9iBu","contentContainer-1":"styles_contentContainer-1__hvFWf","infoContainer-1":"styles_infoContainer-1__pkeve","image-2":"styles_image-2__V1jCK","image-3":"styles_image-3__DpbU5","fernwayer":"styles_fernwayer__T0RzM","thirdSectionView":"styles_thirdSectionView__NDA0d","drive-focus":"styles_drive-focus__bLSTM","fourthSectionView":"styles_fourthSectionView__H1dZE","infoContainer-2":"styles_infoContainer-2__sSgGv","hotel-data-cloud":"styles_hotel-data-cloud__76Un6","infoContainer-3":"styles_infoContainer-3__7OX9C","open-sense":"styles_open-sense__1Bi9f","infoContainer-4":"styles_infoContainer-4___IHDo","image-4":"styles_image-4__wPsVe","separate-us":"styles_separate-us__gPMxx","h3":"styles_h3___R3DB","famlicious":"styles_famlicious__KUV8C","imageBundle-1":"styles_imageBundle-1__HP7VN","contentContainer-4":"styles_contentContainer-4__PQaWw","natp":"styles_natp__nYG3m","travel-trivia":"styles_travel-trivia__t4mFb","cash-chat":"styles_cash-chat__czmgK","tell":"styles_tell__plpO6","ubichat":"styles_ubichat__GfSHl","writer-chrome-extension":"styles_writer-chrome-extension__QUobD","meateater":"styles_meateater__m2yI_","contentContainer-6":"styles_contentContainer-6__KIU1K","image-5":"styles_image-5__PeRdz","bionorica":"styles_bionorica__U6AqF","marketplace-for-clairvoyant-services":"styles_marketplace-for-clairvoyant-services__q5_3T","fusion-markets":"styles_fusion-markets__KK4G9","beautonomy":"styles_beautonomy__PteJ4","telemojo":"styles_telemojo__oSl35","blackbird":"styles_blackbird__CgViD","fintech-app-for-credit-score":"styles_fintech-app-for-credit-score__omNSD","smartcenter":"styles_smartcenter__u4_Er","dindon":"styles_dindon__90HqL","infoContainer-5":"styles_infoContainer-5__mbxdr","contentContainer-5":"styles_contentContainer-5__DAHKl","humankind":"styles_humankind__FwOK1","cinnabar":"styles_cinnabar__OWfEz","contentContainer-7":"styles_contentContainer-7__FjtCD","imageBundle-2":"styles_imageBundle-2__vRoNY","imageBundle-3":"styles_imageBundle-3__W6F3e","imageBundle-4":"styles_imageBundle-4__g0I1G","machine-learning-in-real-estate":"styles_machine-learning-in-real-estate___2IzS","mobile-bank-application":"styles_mobile-bank-application__ew_sD","fifthSectionView":"styles_fifthSectionView__2fbTI","software-for-mri-interpretation":"styles_software-for-mri-interpretation__qbFxL","cedar-valley-farms":"styles_cedar-valley-farms__n8x_j","mobile-budgeting-app":"styles_mobile-budgeting-app__V8H2z","forex-trading-platform":"styles_forex-trading-platform__vA3qg","why-us":"styles_why-us__LC_wd","crowdfunding-platform":"styles_crowdfunding-platform__EcpMN","analytics-for-carbon-tracking":"styles_analytics-for-carbon-tracking__gPbVc","cctv-footage-analytics":"styles_cctv-footage-analytics__AUm8f","web-chat-for-mediums":"styles_web-chat-for-mediums__ibtuk","web-p2p-lending-platform":"styles_web-p2p-lending-platform__Zp9rn","kitchen-equipment-customizer":"styles_kitchen-equipment-customizer__kmyUS","clairvoyant-directory-upgrade":"styles_clairvoyant-directory-upgrade__IFCVl","sectionImage":"styles_sectionImage__ZLQFz","digital-wallet-for-ios":"styles_digital-wallet-for-ios__tJeEh","enterprise-resource-planning-system":"styles_enterprise-resource-planning-system__5qVLl","ai-documentation-processing":"styles_ai-documentation-processing__V6R4C","ai-mobile-cooking-app":"styles_ai-mobile-cooking-app__tNHkC","images-3":"styles_images-3__FfzyZ","images-4":"styles_images-4__dgEWS","images-5":"styles_images-5__ZUWvg","ai-based-travel-planner":"styles_ai-based-travel-planner__Q4Faz","computer-vision-for-aras":"styles_computer-vision-for-aras__dKA5w","penetration-testing-for-healthtech-company":"styles_penetration-testing-for-healthtech-company__dIf9k","pen-testing-for-uk-web-dev-company":"styles_pen-testing-for-uk-web-dev-company__JQYqx","pen-tests-ai":"styles_pen-tests-ai__2uSkx","web-logistics-platform":"styles_web-logistics-platform__BkkQp","ai-feedback-analysis":"styles_ai-feedback-analysis___jKX2","ai-for-edtech":"styles_ai-for-edtech__cy0gE","ai-reporting-assistant":"styles_ai-reporting-assistant__loerc","llm-for-insurtech-saas":"styles_llm-for-insurtech-saas__x06ce","feedback-insight-engine":"styles_feedback-insight-engine__SeE1K","ai-voice-assistant-for-e-learning":"styles_ai-voice-assistant-for-e-learning__WE6kE","ai-assistant-for-chronic-patients":"styles_ai-assistant-for-chronic-patients__BhaVn","ai-warehouse-agent":"styles_ai-warehouse-agent__yEgcm","rag-contract-intelligence-platform":"styles_rag-contract-intelligence-platform__jUn5x","influx":"styles_influx__BfO3Y","futurepay":"styles_futurepay__NKqUA","commod":"styles_commod__RnkCC"};

/***/ }),

/***/ 36157:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"swiper":"styles_swiper__UwtVM","swiperBullet":"styles_swiperBullet__qWZCQ","swiperBulletActive":"styles_swiperBulletActive__bTtGm","stickerbox":"styles_stickerbox__8bLcQ","fairy":"styles_fairy__8bXbm","seven-pm-thursday":"styles_seven-pm-thursday__wfGyS","fernwayer":"styles_fernwayer__N9SO_","open-sense":"styles_open-sense__yRevP","separate-us":"styles_separate-us__6Qmf0","famlicious":"styles_famlicious__Zq_UJ","natp":"styles_natp__neWzF","travel-trivia":"styles_travel-trivia__Z1JFG","cash-chat":"styles_cash-chat__XgTga","tell":"styles_tell__pDQ6c","ubichat":"styles_ubichat__uH4gb","writer-chrome-extension":"styles_writer-chrome-extension__h3bXH","bionorica":"styles_bionorica__VdEMw","dindon":"styles_dindon__Jr5W_","cinnabar":"styles_cinnabar__AXqel","machine-learning-in-real-estate":"styles_machine-learning-in-real-estate__WK15H","mobile-budgeting-app":"styles_mobile-budgeting-app__lQ8Qi","thirdSectionView":"styles_thirdSectionView__7g3_z","forex-trading-platform":"styles_forex-trading-platform__QNFqc","web-chat-for-mediums":"styles_web-chat-for-mediums__Pq7uu","meateater":"styles_meateater__b_y3H","mobile-bank-application":"styles_mobile-bank-application__N_OKM","penetration-testing-for-healthtech-company":"styles_penetration-testing-for-healthtech-company__hynRR","ai-for-edtech":"styles_ai-for-edtech___FSPz"};

/***/ }),

/***/ 31890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__T17hn"};

/***/ }),

/***/ 5713:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navButton":"styles_navButton___E8aQ","text":"styles_text__fy5hq","next":"styles_next__89xlm"};

/***/ }),

/***/ 35133:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navigationContainer":"styles_navigationContainer__cgD9j"};

/***/ }),

/***/ 30706:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 92:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 68770:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 13390:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 30933:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 31304:
/***/ (function(module) {


;(function (name, root, factory) {
  if (true) {
    module.exports = factory()
    module.exports["default"] = factory()
  }
  /* istanbul ignore next */
  else {}
}('slugify', this, function () {
  var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E\'","Ը":"Y\'","Թ":"T\'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C\'","Կ":"K","Հ":"H","Ձ":"D\'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R\'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P\'","Ք":"Q\'","Օ":"O\'\'","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","„":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}')
  var locales = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}')

  function replace (string, options) {
    if (typeof string !== 'string') {
      throw new Error('slugify: string argument expected')
    }

    options = (typeof options === 'string')
      ? {replacement: options}
      : options || {}

    var locale = locales[options.locale] || {}

    var replacement = options.replacement === undefined ? '-' : options.replacement

    var trim = options.trim === undefined ? true : options.trim

    var slug = string.normalize().split('')
      // replace characters based on charMap
      .reduce(function (result, ch) {
        var appendChar = locale[ch];
        if (appendChar === undefined) appendChar = charMap[ch];
        if (appendChar === undefined) appendChar = ch;
        if (appendChar === replacement) appendChar = ' ';
        return result + appendChar
          // remove not allowed characters
          .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, '')
      }, '');

    if (options.strict) {
      slug = slug.replace(/[^A-Za-z0-9\s]/g, '');
    }

    if (trim) {
      slug = slug.trim()
    }

    // Replace spaces with replacement character, treating multiple consecutive
    // spaces as a single space.
    slug = slug.replace(/\s+/g, replacement);

    if (options.lower) {
      slug = slug.toLowerCase()
    }

    return slug
  }

  replace.extend = function (customMap) {
    Object.assign(charMap, customMap)
  }

  return replace
}))


/***/ })

}]);